import classNames from 'classnames';
import { ReactChild } from 'react';
import './SnackBodyBaseForm.css';

interface Props {
  className?: string;
  title?: string;
  message?: ReactChild;
  icon?: React.ReactNode;
}

export const SnackBodyBaseForm = ({ title, message, className, icon }: Props) => {
  return (
    <div className={classNames('snackinfo-notification', className)}>
      <div className="snackinfo-notification__icon-column">{icon}</div>
      <div className="snackinfo-notification__body-column">
        <div className="snackinfo-notification__title">{title}</div>
        <div className="snackinfo-notification__body">{message}</div>
      </div>
    </div>
  );
};
